import styled from 'styled-components'

export const LoaderContainer = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const NoTasksText = styled.span`
  color: ${({ theme }) => theme.colors.text};
  font-size: 16px;
`
